import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';
import AppLayout from './AppLayout';
import Overview from './Overview';   // Updated Overview component for resume matching
import ResumeDetail from './ResumeDetail'; // New component for resume details
import Profile from './Profile';
import ChangeEmailPage from './ChangeEmailPage';
import ReauthenticatePage from './ReauthenticatePage';
import NewPasswordPage from './NewPasswordPage';
import ProtectedRoute from './ProtectedRoute';
import DeleteAccountConfirmPage from './DeleteAccountConfirmPage';
import { AuthProvider } from './AuthContext';
import AppHomeRedirect from './AppHomeRedirect';
import './App.css';  // Make sure to use the updated App.css

function App() {
  return (
    <AuthProvider>
      <Router basename="/app">
        <Routes>
          <Route path="/" element={<AppHomeRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          
          <Route path="/dashboard" element={<AppLayout />}>
            <Route index element={<ProtectedRoute requireAuth={false}><Overview /></ProtectedRoute>} />
            <Route path="overview" element={<ProtectedRoute requireAuth={false}><Overview /></ProtectedRoute>} />
            <Route path="resume/:resumeId" element={<ProtectedRoute><ResumeDetail /></ProtectedRoute>} />
            <Route path="profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="reauthenticate" element={<ProtectedRoute><ReauthenticatePage /></ProtectedRoute>} />
            <Route path="new-password" element={<ProtectedRoute><NewPasswordPage /></ProtectedRoute>} />
            <Route path="change-email" element={<ProtectedRoute><ChangeEmailPage /></ProtectedRoute>} />
            <Route path="delete-account-confirm" element={<ProtectedRoute><DeleteAccountConfirmPage /></ProtectedRoute>} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;